import {
  RegisterTeamActivityStatus
} from 'app/api/event/model'
import { useGetActionRegisteredByTeam } from 'app/react-query/hook/event'
import { useAppSelector } from 'app/redux/hooks'
import { useMemo } from 'react'


export const useActionRegisteredByStatusHook = ({
  status,
}: {
  status: RegisterTeamActivityStatus
}) => {
  const user = useAppSelector(state => state?.user)?.profile
  const { data: response, isLoading } = useGetActionRegisteredByTeam({
    createdById: user?.member?.id,
    status,
  })

  const data = useMemo(() => {
    return response?.data?.map((item, index) => {
      return {
        ...item,
        key: index + 1,
        index: index + 1,
      }
    })
  }, [response])

  return { data, isLoading }
}
